import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import useOnScreen from '@/lib/hooks/use-on-screen';
import { setIsWelcomeAdVisible } from '@/store/slices/ads';

import Advertisement from '../../../advertisement';

interface WelcomeAdProps {
  isMobile: boolean;
}

const WelcomeAd = ({ isMobile }: WelcomeAdProps) => {
  const ref = useRef(null);
  const isOnScreen = useOnScreen(ref);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isMobile) {
      dispatch(setIsWelcomeAdVisible(isOnScreen));
    }
  }, [dispatch, isMobile, isOnScreen]);

  return (
    <div className="relative !z-[30]">
      <Advertisement slot="top_special_1" ref={ref} />
    </div>
  );
};

export default WelcomeAd;
